module.exports = __webpack_public_path__ + "static/media/weddingBandRound.c9e7e14c.png";